import $ from 'jquery';
import { onPageLoad } from '@/js/modules/page_load';

onPageLoad(() => {
  $(function () {
    const scrollBuffer = 300;

    const loadActivities = (url) => {
      $('.activity-log').append('<div class="activity-log__loading">Loading...</div>');

      const lastLoadedDate = $('.activity-log__date').last().data().date;

      $.ajax({
        url,
        data: { lastLoadedDate },
        type: 'GET',
        dataType: 'json',
      })
        .done((data) => {
          $('.activity-log').append(data.html);
          if (data.next_page === null) {
            $('.activity-log').removeData('next-page');
          } else {
            $('.activity-log').data().nextPage = data.next_page;
          }
          groupMessageActivityLogs();
        })
        .always(() => {
          $('.activity-log').find('.activity-log__loading').remove();
        });
    };
    $(window).scroll((e) => {
      if ($('body').is('#activity_logs')) {
        const $this = $(e.target);
        const height = Math.floor($(document).height() - $(window).height()); // Get the height of the div
        const scroll = Math.ceil($this.scrollTop()); // Get the vertical scroll position

        const isScrolledToEnd = scroll + scrollBuffer >= height;
        if (isScrolledToEnd) {
          const $activityLog = $('.activity-log');

          if (!$activityLog.length) {
            return;
          }

          const projectId = $activityLog.data().projectId;
          const nextPage = parseInt($activityLog.data().nextPage, 10);

          if ($('.activity-log__loading').length || Number.isNaN(nextPage)) {
            return;
          }

          loadActivities(`/projects/${projectId}/activity_logs?page=${nextPage}`);
        }
      }
    });
  });

  function groupMessageActivityLogs() {
    $('.activity-log-record--message').each(function () {
      if (!$(this).hasClass('activity-log-record--message')) {
        return;
      }

      const $messageGroup = $(this).nextUntil(
        ':not(.activity-log-record--message)',
        '.activity-log-record--message'
      );
      const totalMessages = $messageGroup.length + 1;

      if (totalMessages > 2) {
        const $secondMessage = $messageGroup.eq(0);
        const additionalMessages = totalMessages - 1;
        const fadeElement = '<div class="activity-log-record__fade"></div>';
        const moreMessagesLink = $(this).find('.h-s-button--open-discussion-panel').attr('href');
        const moreMessagesText = `<div class="activity-group-divider">
          <a href="${moreMessagesLink}" class="h-s-button button-md h-s-button--open-discussion-panel h-s-button--activity-group">
            + ${additionalMessages} additional ${additionalMessages === 1 ? 'message' : 'messages'}
          </a>
        </div>`;

        $secondMessage
          .addClass('activity-log-record--with-fade')
          .append(fadeElement)
          .after(moreMessagesText);
        $messageGroup.slice(1).remove();
      }
    });
  }

  groupMessageActivityLogs();
});
